import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Basket, BasketService } from '../basket.service';
import { customer, CustomerService } from '../customer.service';
import { Order, OrderService } from '../order.service';

export interface DialogData {
  name: string;
}
@Component({
  selector: 'app-cart-display',
  templateUrl: './cart-display.component.html',
  styleUrls: ['./cart-display.component.css']
})
export class CartDisplayComponent implements OnInit {
  @Input() total_price: number = 0.0;
  @Input() total_item: number = 0;
  @Input() orderID: number = 0;
  @Input() basket: Basket[] = [];
  @Output() order: EventEmitter<Order[]> = new EventEmitter<Order[]>();
  customer_name: string = '';
  customer_id: number = 0;
  customerOfDay: customer[] = [];
  customerForm = new FormControl();
  options: customer[] = [];
  customerList!: Observable<customer[]>;
  date: number = Date.now()
  constructor(
    private basketService: BasketService,
    private orderService: OrderService,
    public dialog: MatDialog,
    private customerService: CustomerService) {
    this.basket = this.basketService.items
  }

  displayedColumns: string[] = ['no', 'name', 'unit', 'quantity', 'wholesale_price', 'amount', 'choose'];

  ngOnInit(): void {
    this.customerService.getAll().subscribe((data) => {
      this.options = data;
      this.customerList = this.customerForm.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filter(name) : this.options.slice())
        );
    }, (err) => {
      console.log('getAll', err);
    })
  }

  removeItem(id: number) {
    this.basketService.removeItem(id);
    this.basket = this.basketService.getItems();
    this.total_price = this.basketService.getTotalPrice().wholesale_total;
    this.total_item = this.basketService.getTotalPrice().item_total;
  }
  clearCart() {
    this.basket = this.basketService.clearCart();
    this.total_price = 0;
    this.total_item = 0;
    this.orderID = 0;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(SaveDialog, {
      width: '250px',
      data: { name: this.customer_name }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.customer_name = result;
        this.saveOrder();
      }
    });
  }
  saveOrder() {
    if (this.basket.length > 0) {
      this.orderService.saveOrder(this.orderID, this.basket, this.customer_name, this.customer_id).subscribe(
        (data) => {
          // this.orderService.GetAll().subscribe((data) => {
          //   this.order.emit(data);
          //   this.customer_name = '';
          // })
          this.clearCart()
        },
        (err) => {
          console.log("save order error", err);
        }
      );
    } else {
      console.log('save order basket empty');
    }
  }

  selectCustomer(customer: customer) {
    this.customer_name = customer.name;
    this.customer_id = customer.id;
    this.date = Date.now()
  }
  displayFn(user: customer): string {
    return user && user.name ? user.name : '';
  }

  private _filter(name: string): customer[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }
}

@Component({
  selector: 'save-dialog',
  templateUrl: 'save-dialog.html',
})
export class SaveDialog {

  constructor(
    public dialogRef: MatDialogRef<SaveDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}